<template>
  <v-dialog
    :value="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-bind="$attrs"
    @input="onClose"
  >
    <v-card>
      <v-window
        v-model="window"
        reverse
        vertical
      >
        <v-window-item>
          <v-card-text
            v-if="loading"
            class="px-12 py-16"
          >
            Ladataan...
            <v-progress-linear
              indeterminate
              color="primary"
              class="mb-0"
            />
          </v-card-text>
        </v-window-item>

        <v-window-item>
          <slot/>
        </v-window-item>
      </v-window>

      <span :class="{ 'is-active': scrollable.bottom }" class="shadow-bottom"/>

      <v-card-actions class="grey lighten-5">
        <v-spacer/>
        <slot name="actions"/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GroupDashboardAgentDialog',

  props: {
    loading: {
      type: Boolean,
      default: true,
    },

    scrollable: {
      type: Object,
      default: () => ({}),
    },

    show: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    window: 0,
  }),

  watch: {
    loading(loading) {
      this.window = loading ? 0 : 1;
    },

    show(show) {
      if (!show) {
        this.window = 0;
      }
    },
  },

  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.shadow-top,
.shadow-right,
.shadow-bottom,
.shadow-left {
  position: absolute;
  border-radius: 6em;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}

.shadow-top,
.shadow-bottom {
  right: 0;
  left: 0;
  height: 8px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  background-image: linear-gradient(rgba(#555, 0.1) 0%, rgba(#FFF, 0) 100%);
}

.shadow-top {
  top: 0;
}

.shadow-bottom {
  bottom: 52px;
  transform: rotate(180deg);
}

.is-active {
  opacity: 1;
}
</style>
